"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_1 = __importDefault(require("@tencent/vft-common/cookie"));
var languages_1 = require("../config/languages");
var constants_1 = require("../utils/constants");
// 获取url参数
var searchParams = new URLSearchParams(location.search);
var context = {
    lang: searchParams.get('lang'),
    langCode: Number(searchParams.get('langCode')),
};
/**
 * 获取语言设置，优先级，urlParams.lang > urlParams.langCode > UA > cookie.wetv_lang > 默认(en)
 * @returns {LangType}
 */
function getLang() {
    // 如果url有指定lang参数，设置页面语言码
    if (context.lang) {
        return {
            code: languages_1.findLangCodeByName(context.lang),
            name: context.lang,
        };
    }
    // 如果url有指定langCode参数，设置页面语言码
    if (context.langCode) {
        return {
            code: context.langCode,
            name: languages_1.findLangNameByCode(context.langCode),
        };
    }
    // 返回ua中指定的语言码
    var result = navigator.userAgent.match(/Language\/([0-9]+)\(\s?([a-z-]+)\s?\)/);
    if (result && result.length > 2) {
        var code = Number(result[1]);
        var name_1 = result[2];
        return {
            code: code,
            name: name_1,
        };
    }
    var langNameInCookie = cookie_1.default.get('wetv_lang');
    if (langNameInCookie) {
        return {
            code: languages_1.findLangCodeByName(langNameInCookie),
            name: langNameInCookie,
        };
    }
    // 兜底国家为英语
    return {
        code: constants_1.DEFAULT_LANG.code,
        name: constants_1.DEFAULT_LANG.name,
    };
}
// 语言码
var LANG = getLang();
exports.default = LANG;
